// @ts-nocheck
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Row, Col, Input, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Message from 'shared_components/message';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import { updateAnnouncementAPI } from 'services/system_setup/announcement';
import { UserAccessContext } from 'context/userAccess';

export default function SetAnnouncements(props){
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['systemSetup'].update;

    const formRef = useRef();
    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
    const [allDisabled, setAllDisabled] = useState(false)

    useEffect(()=> {
        if(updateRight === 'TRUE'){
            setAllDisabled(false)
        }else{
            setAllDisabled(true)
        }
    })

    async function handleSubmit(formValues){
        const userID = loggedinUser.userID;
        try {
            const res = await updateAnnouncementAPI(formValues, userID)
            if(res.data.announcement_header !== undefined){
                Message.success({ message: 'ANNOUNCEMENT SUCCESSFULLY UPDATED' });
                window.location.reload(false);
            }else{
                Message.success({ message: 'ANNOUNCEMENT ERROR: NOT UPDATED' });
            }

        } catch (error) {
            console.log('ANNOUNCEMENT Error :', error);
            Message.error(error);
        }
    };
    
    return(
        <div>
            <Form
                layout='vertical'
                onFinish={handleSubmit}
                ref={formRef}
            >
                <Row gutter={[8, 1]} align='bottom'>
                    <Col className="gutter-row" span={24} >
                        <Form.Item name='annTitle' 
                            label='TITLE'
                        >
                            <Input style={{ width:'100%' }} disabled={allDisabled} ></Input>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[8, 1]} align='bottom'>
                    <Col className="gutter-row" span={24} >
                        <Form.Item name='annContent' 
                            label='CONTENT'
                        >
                            <TextArea disabled={allDisabled}></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[8, 1]} justify='end'>
                    <Col className="gutter-row" >
                        <Form.Item>
                            <Button
                                className="login-form-button"
                                type="primary"
                                htmlType='submit'
                                disabled={allDisabled}
                            >
                                SAVE
                            </Button>
                            <Button style={{ marginLeft: '5px' }} disabled={allDisabled} >
                                Clear
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[8, 1]} align='middle'>
                    <Col style={ {marginTop:'10px'} }>
                        <h3>Current Announcement</h3>
                        <p><strong>Title : </strong>{props.ann.announcement_header}</p>
                        <p><strong>Content : </strong>{props.ann.announcement_content}</p>
                    </Col>
                </Row>
            </Form>
        </div>
    )
};